export const columns = [
  {
    title: "系统名称",
    width: 150,
    key: "systemName",
    slots: { customRender: "systemName" },
  },
  {
    title: "清单编号",
    width: 200,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "材料名称",
    width: 200,
    dataIndex: "materialName",
    key: "materialName",
  },
  {
    title: "规格型号",
    width: 150,
    dataIndex: "materialModel",
    key: "materialModel",
  },
  {
    title: "品牌",
    width: 100,
    dataIndex: "materialBrand",
    key: "materialBrand",
  },
  {
    title: "结算单位",
    width: 100,
    dataIndex: "materialUnit",
    key: "materialUnit",
  },
  {
    title: "申请数量",
    width: 150,
    dataIndex: "applyCount",
    key: "applyCount",
  },
  {
    title: "预算成本价(元)",
    width: 150,
    dataIndex: "costPrice",
    key: "costPrice",
    slots: { title: "costPriceTitle" },
  },
  {
    title: "市场销售价(元)",
    width: 150,
    dataIndex: "salesPrice",
    key: "salesPrice",
    slots: { title: "salesPriceTitle" },

  },
  {
    title: "预算单价",
    width: 150,
    key:'budgetPrice',
    slots: { customRender: "budgetPrice" },
  },
];
